import * as THREE from "three";

/** Scroll the decoration in UV space while preserving the canvas text. */
export class MenuMaterial extends THREE.MeshBasicMaterial {
  readonly scrollTime = { value: 0 };

  constructor(map: THREE.Texture, bounds: THREE.Vector4) {
    super({ map, transparent: true, depthWrite: false, depthTest: false, toneMapped: false });
    this.onBeforeCompile = shader => {
      shader.uniforms.menuTime = this.scrollTime;
      shader.uniforms.menuBounds = { value: bounds };
      shader.vertexShader = `varying vec2 menuUv;\n${shader.vertexShader}`
        .replace("#include <begin_vertex>", "#include <begin_vertex>\nmenuUv = uv;");
      shader.fragmentShader = `uniform float menuTime;\nuniform vec4 menuBounds;\nvarying vec2 menuUv;\n${shader.fragmentShader}`
        .replace("#include <map_fragment>", `#include <map_fragment>
          vec2 panelUv = (menuUv - menuBounds.xy) / (menuBounds.zw - menuBounds.xy);
          float inside = step(0.0, panelUv.x) * step(panelUv.x, 1.0) * step(0.0, panelUv.y) * step(panelUv.y, 1.0);
          float edge = min(min(panelUv.x, 1.0 - panelUv.x), min(panelUv.y, 1.0 - panelUv.y));
          float rim = 1.0 - smoothstep(0.002, 0.018, edge);
          float halo = 1.0 - smoothstep(0.012, 0.055, edge);
          float phase = fract(panelUv.y + panelUv.x * 0.24 - menuTime * 0.14);
          float sweep = smoothstep(0.0, 0.06, phase) * (1.0 - smoothstep(0.06, 0.32, phase));
          vec3 neon = mix(vec3(0.02, 0.82, 1.0), vec3(0.72, 0.10, 0.95), 0.5 + 0.5 * sin(phase * 6.283185));
          float ink = max(max(diffuseColor.r, diffuseColor.g), diffuseColor.b);
          float background = (1.0 - smoothstep(0.08, 0.32, ink)) * diffuseColor.a;
          vec2 grid = abs(fract(panelUv * vec2(24.0, 14.0) + vec2(menuTime * 0.025, -menuTime * 0.035)) - 0.5);
          float traces = smoothstep(0.46, 0.49, max(grid.x, grid.y));
          diffuseColor.rgb += inside * neon * (
            rim * (0.3 + sweep * 0.85) + halo * sweep * 0.10
            + background * (sweep * 0.13 + traces * 0.025));
          diffuseColor.a = max(diffuseColor.a, inside * rim * 0.85);
        `);
    };
  }

  override customProgramCacheKey(): string { return "dual-stack-menu-uv-scroll-v1"; }
}
